CDN.requireOnce([
    { code: CDN.PackageCode.JQuery, },
    { code: CDN.PackageCode.Common, },
    { code: CDN.PackageCode.Control_HorizontalDateTimePicker, },
], () => {
    let lightdiv = $("<div theme='light' style='width: 940px;height: 120px;padding: 10px;'>");
    let darkdiv = $("<div theme='dark' style='width: 940px;height: 120px;padding: 10px;'>");
    $("body").append(lightdiv);
    $("body").append(darkdiv);

    let createPicker = (div: HTMLElement) => {
        let dtPicker = new CDN.Controls.UI.DateTime.HorizontalDateTimePicker(div, {
            onDateTimeSelected: (datetime) => {
                dtLbl.text(datetime.format("yyyy/MM/dd HH:mm:ss"));
            },
            from: new Date(Date.today().getTime() - 30 * 1000 * 60 * 60 * 24),
            to: new Date(Date.now()),
            disableFutureIntervals: true,
            disableInterval: (datetime) => {
                return datetime.getTime() > Date.today().getTime() + 10 * 1000 * 60 * 60 * 24 ||
                    datetime.getTime() < Date.today().getTime() - 20 * 1000 * 60 * 60 * 24;
            },
        });
    };

    createPicker(lightdiv.get(0));
    createPicker(darkdiv.get(0));

    let dtLbl = $("<label>");
    $("body").append(dtLbl);

    dtLbl.text(new Date(Math.floor(Date.now() / 60 / 1000) * 60 * 1000).format("yyyy/MM/dd HH:mm:ss"));
});